/**
 * Small "224 fps" readout in the top-right corner (2026-10-26), standing in
 * for the stats panel while that panel is closed - the same number as the
 * panel's Performance row (main.ts's 1 s frame window), whole frames only.
 *
 * Shown only while the stats panel is closed, and only while the playback
 * bar is: main.ts forwards the bar's idle fade (onIdleChange), so the two
 * appear on mouse movement and fade after the same 2 s, and hovering the
 * bar keeps both up. Never takes the pointer. Sized with the stats panel's
 * factor (ftgs-fps-badge.scss), so it grows with it on Windows / macOS.
 */
class FtgsFpsBadge {
    readonly dom: HTMLDivElement;
    private statsOpen = false;
    private idle = false;

    constructor() {
        this.dom = document.createElement('div');
        this.dom.id = 'ftgs-fps-badge';
        this.dom.textContent = '- fps';
        this.apply();
    }

    /** the latest windowed frame rate; skipped while the badge can't be seen */
    setFps(fps: number) {
        if (this.statsOpen || this.idle) {
            return;
        }
        this.dom.textContent = fps > 0 && Number.isFinite(fps) ? `${Math.round(fps)} fps` : '- fps';
    }

    /** the stats panel shows the same number, so the badge steps aside */
    setStatsOpen(open: boolean) {
        this.statsOpen = open;
        this.apply();
    }

    /** the playback bar's idle fade (true = faded out) */
    setIdle(idle: boolean) {
        this.idle = idle;
        this.apply();
    }

    private apply() {
        this.dom.classList.toggle('ftgs-fps-badge-off', this.statsOpen);
        this.dom.classList.toggle('ftgs-fps-badge-idle', this.idle);
    }
}

export { FtgsFpsBadge };
